import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { selectAuthStoreReady, selectLoggedInGuardValue } from "../../store/auth/auth.selectors";
import { PortalRole } from "../../model/auth.model";
import { Observable } from "rxjs";
import { selectMaintenanceIsActiveFiltered, selectMaintenanceScheduleStoreInit } from "../../store/maintenance-schedule/maintenance-schedule.selectors";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService {
    private store = inject(Store);
    private router = inject(Router);

    private loggedInGuard$ = this.store.select(selectLoggedInGuardValue);
    private authStoreReady$ = this.store.select(selectAuthStoreReady);
    private maintenanceIsActive$ = this.store.select(selectMaintenanceIsActiveFiltered);
    private maintenanceIsLoaded$ = this.store.select(selectMaintenanceScheduleStoreInit);


    /**
     * Get the loggin status and user role from the store as an observable
     * @returns an object that holds the loggin status and 
     */
    getLoggedInGuard(): Observable<{ role: PortalRole | null, loggedIn: boolean }> {
        return this.loggedInGuard$
    }

    /**
     * Get if the authStore was fully initialized for the first time as an observable
     * @returns if the authStore was initialized
     */
    authStoreReady(): Observable<boolean> {
        return this.authStoreReady$
    }

    /**
     * Get if the maintenanceStore was fully initialized for the first time as an observable
     * @returns if the maintenanceStore was initialized
     */
    maintenanceIsLoaded(): Observable<boolean> {
        return this.maintenanceIsLoaded$
    }

    /**
     * Get the maintenance status from the store as an observable
     * @returns if a maintenance is currently active
     */
    maintenanceIsActive(): Observable<boolean> {
        return this.maintenanceIsActive$
    }

    redirectByRole(role: PortalRole | null): void {
        switch (role) {
            case null:
                break;
            case PortalRole.COMPANY_SELECT:
                this.router.navigate(['/start']);
                break;
            case PortalRole.COMPANY_ADMIN:
                this.router.navigate(['/unternehmensverwaltung']);
                break;
            case PortalRole.FFA_ADMIN:
                this.router.navigate(['/ffaverwaltung']);
                break;
            default:
                this.router.navigate(['/alle-antraege']);
                break;
        }
    }
}